import { createLogic } from "redux-logic";
import type { ShowModalType } from "../../../../common-deprecated/redux/actions/ModalActions";
import { SHOW_MODAL } from "../../../../common-deprecated/redux/actions/ModalActions";
import { getTotalPriceSelector } from "../../utils/priceUtils";
import { MODAL_USC_FORM } from "../../../shared-logic/utils/integrated-modal/integratedModalConstants";
import { UscFinanceDataSource } from "../../utils/constants";
import type { UscLogicType } from "../store";

// Propagate USC data to the UscForm modal.
const modalLogic = (createLogic as UscLogicType<ShowModalType>)({
    type: SHOW_MODAL,

    transform({ getState, action }, allow) {
        if (action.settings.type === MODAL_USC_FORM) {
            const { insurance, finance, externalPrice } = getState();
            const { monthlyPrice, cashPrice } = getTotalPriceSelector()(getState());

            /**
             * onCarFilter is a flag that is set to true whenever the form is opened in a Car Filter context.
             * This can be on the actual Car Filter page, or on the PDP Similar Cars section.
             * In this case, we don't want to propagate the data to the form, as the user
             * has not yet been able to configure their reservation for this specific car.
             */
            if (!action.settings.onCarFilter) {
                action.settings.externalData = {
                    ...action.settings.externalData,
                    makolabInsuranceData: insurance.quote || null,
                    makolabFinanceData:
                        finance.latestResponse?.source === UscFinanceDataSource.ApiUsed ||
                        finance.latestResponse?.source === UscFinanceDataSource.ApiStock
                            ? finance.latestResponse?.data
                            : null,
                    externalPriceData: externalPrice.data || null,
                    externalPriceInfo: { monthlyPrice, cashPrice, financeInfo: finance.info },
                };
            }
        }

        allow(action);
    },
});

export default [modalLogic];
